export const slugsPart5 = {
    "P5.js": "p5dotjs",
    "Packagist": "packagist",
    "Packer": "packer",
    "Paddle": "paddle",
    "PaddlePaddle": "paddlepaddle",
    "Paddy Power": "paddypower",
    "Pagekit": "pagekit",
    "PagerDuty": "pagerduty",
    "Pagespeed Insights": "pagespeedinsights",
    "PagSeguro": "pagseguro",
    "Palantir": "palantir",
    "Palo Alto Networks": "paloaltonetworks",
    "Palo Alto Software": "paloaltosoftware",
    "Pan-Am": "panam",
    "Pandas": "pandas",
    "Pandora": "pandora",
    "Pantheon": "pantheon",
    "Paperless-ngx": "paperlessngx",
    "PaperMC": "papermc",
    "Paperspace": "paperspace",
    "Paramount+": "paramountplus",
    "Parity Substrate": "paritysubstrate",
    "Parse": "parse",
    "Parsley": "parsley",
    "Particule": "particule",
    "Party City": "partycity",
    "Patreon": "patreon",
    "Paychex": "paychex",
    "Payload": "payload",
    "Payoneer": "payoneer",
    "PayPal": "paypal",
    "Paytm": "paytm",
    "PC Gamer": "pcgamer",
    "PCGamingWiki": "pcgamingwiki",
    "PDQ": "pdq",
    "Peak Design": "peakdesign",
    "Pearson": "pearson",
    "PeerTube": "peertube",
    "Pegasus Airlines": "pegasusairlines",
    "Pelican": "pelican",
    "Peloton": "peloton",
    "Penny": "penny",
    "Penpot": "penpot",
    "Pepsi": "pepsi",
    "Percy": "percy",
    "Perforce": "perforce",
    "Perplexity": "perplexity",
    "Persistent": "persistent",
    "Personio": "personio",
    "Pets at Home": "petsathome",
    "Peugeot": "peugeot",
    "Pexels": "pexels",
    "pfsense": "pfsense",
    "Phabricator": "phabricator",
    "Phantom": "phantom",
    "Philip Morris International": "philipmorrisinternational",
    "Philips": "philips",
    "Philips Hue": "philipshue",
    "PhonePe": "phonepe",
    "Photopea": "photopea",
    "PHP": "php",
    "phpMyAdmin": "phpmyadmin",
    "PHPStorm": "phpstorm",
    "Pi-hole": "pihole",
    "Picards": "picards",
    "Picart": "picart",
    "Pico": "pico",
    "PicPay": "picpay",
    "Pie": "pie",
    "Piwigo": "piwigo",
    "Pixabay": "pixabay",
    "Pixart": "pixart",
    "Pixiv": "pixiv",
    "PJSIP": "pjsip",
    "PKP": "pkp",
    "Placekit": "placekit",
    "Planet": "planet",
    "PlanetScale": "planetscale",
    "Plausible Analytics": "plausibleanalytics",
    "Play Canvas": "playcanvas",
    "Player.me": "playerdotme",
    "PlayStation": "playstation",
    "PlayStation 2": "playstation2",
    "PlayStation 3": "playstation3",
    "PlayStation 4": "playstation4",
    "PlayStation 5": "playstation5",
    "PlayStation Vita": "playstationvita",
    "Playwright": "playwright",
    "Pleroma": "pleroma",
    "Plesk": "plesk",
    "Plex": "plex",
    "Plotly": "plotly",
    "Plume": "plume",
    "Pluralsight": "pluralsight",
    "Plurk": "plurk",
    "Plus": "plus",
    "PM2": "pm2",
    "pnpm": "pnpm",
    "Pocket": "pocket",
    "Pocket Casts": "pocketcasts",
    "PocketBase": "pocketbase",
    "Podcast Addict": "podcastaddict",
    "Podcast Index": "podcastindex",
    "Podman": "podman",
    "Poetry": "poetry",
    "Pointy": "pointy",
    "Pokémon": "pokemon",
    "Polars": "polars",
    "Polestar": "polestar",
    "Policy Sentry": "policysentry",
    "Polkadot": "polkadot",
    "Poly": "poly",
    "Polymer Project": "polymerproject",
    "Polywork": "polywork",
    "Pons": "pons",
    "Pop!_OS": "popos",
    "Porsche": "porsche",
    "Portainer": "portainer",
    "Portswigger": "portswigger",
    "PostCSS": "postcss",
    "PostgreSQL": "postgresql",
    "Posthog": "posthog",
    "Postman": "postman",
    "Postmates": "postmates",
    "Power Automate": "powerautomate",
    "Power BI": "powerbi",
    "Power Virtual Agents": "powervirtualagents",
    "PowerApps": "powerapps",
    "PowerArt": "powerart",
    "PowerFuzzer": "powerfuzzer",
    "PowerPages": "powerpages",
    "PowerShell": "powershell",
    "PowerToys": "powertoys",
    "Pr.co": "prdotco",
    "Pre-commit": "precommit",
    "Preact": "preact",
    "Prefect": "prefect",
    "Premier League": "premierleague",
    "PrestaShop": "prestashop",
    "Presto": "presto",
    "Prettier": "prettier",
    "Prevention": "prevention",
    "Prezi": "prezi",
    "Prime": "prime",
    "Prime Video": "primevideo",
    "Prisma": "prisma",
    "Prismic": "prismic",
    "Private Internet Access": "privateinternetaccess",
    "Probot": "probot",
    "Processing Foundation": "processingfoundation",
    "ProcessWire": "processwire",
    "Product Hunt": "producthunt",
    "Progate": "progate",
    "Progress": "progress",
    "Prometheus": "prometheus",
    "ProSieben": "prosieben",
    "Proteus": "proteus",
    "Protocols.io": "protocolsdotio",
    "Proton": "proton",
    "Proton Drive": "protondrive",
    "Proton Mail": "protonmail",
    "Proton Pass": "protonpass",
    "Proton VPN": "protonvpn",
    "Proxmox": "proxmox",
    "Publons": "publons",
    "Pubmed": "pubmed",
    "Pug": "pug",
    "Pulumi": "pulumi",
    "Puma": "puma",
    "Puppet": "puppet",
    "Puppeteer": "puppeteer",
    "PureScript": "purescript",
    "PurgeCSS": "purgecss",
    "Purism": "purism",
    "Pusher": "pusher",
    "PWA": "pwa",
    "PyCaret": "pycaret",
    "Pycharm": "pycharm",
    "Pydantic": "pydantic",
    "PyG": "pyg",
    "PyPI": "pypi",
    "PyPy": "pypy",
    "Pyramid": "pyramid",
    "PyScript": "pyscript",
    "Pytest": "pytest",
    "Python": "python",
    "Python Poetry": "pythonpoetry",
    "PyTorch": "pytorch",
    "PyTorch Lightning": "pytorchlightning",
    "PyUp": "pyup",
    "Qantas": "qantas",
    "Qatar Airways": "qatarairways",
    "QB": "qb",
    "Qdrant": "qdrant",
    "Qiita": "qiita",
    "QIWI": "qiwi",
    "Qlik": "qlik",
    "QMK": "qmk",
    "Qt": "qt",
    "Qualcomm": "qualcomm",
    "Qualtrics": "qualtrics",
    "Qualys": "qualys",
    "Quantcast": "quantcast",
    "QuantConnect": "quantconnect",
    "Quantum Creators": "quantumcreators",
    "Quarkus": "quarkus",
    "Quasar": "quasar",
    "Qubes OS": "qubesos",
    "Quest": "quest",
    "QuickBooks": "quickbooks",
    "QuickLook": "quicklook",
    "Quicksilver": "quicksilver",
    "QuickTime": "quicktime",
    "Quip": "quip",
    "Quora": "quora",
    "Qwik": "qwik",
    "Qwiklabs": "qwiklabs",
    "R": "r",
    "R3": "r3",
    "RabbitMQ": "rabbitmq",
    "Racket": "racket",
    "Radar": "radar",
    "Radarr": "radarr",
    "RadioPublic": "radiopublic",
    "Radix UI": "radixui",
    "Radmon": "radmon",
    "Railway": "railway",
    "Rainmeter": "rainmeter",
    "Rakuten": "rakuten",
    "RAM": "ram",
    "Rancher": "rancher",
    "Rarible": "rarible",
    "Rasa": "rasa",
    "Raspberry Pi": "raspberrypi",
    "Razer": "razer",
    "Razorpay": "razorpay",
    "Ray": "ray",
    "Raycast": "raycast",
    "React": "react",
    "React Bootstrap": "reactbootstrap",
    "React Hook Form": "reacthookform",
    "React Query": "reactquery",
    "React Router": "reactrouter",
    "React Table": "reacttable",
    "ReactiveX": "reactivex",
    "ReactOS": "reactos",
    "Read the Docs": "readthedocs",
    "Read.cv": "readdotcv",
    "Realm": "realm",
    "Reason": "reason",
    "Reason Studios": "reasonstudios",
    "Recoil": "recoil",
    "Red": "red",
    "Red Hat": "redhat",
    "Red Hat OpenShift": "redhatopenshift",
    "Redbubble": "redbubble",
    "Reddit": "reddit",
    "Redis": "redis",
    "Redmine": "redmine",
    "Redox": "redox",
    "Redux": "redux",
    "Redux-Saga": "reduxsaga",
    "RedwoodJS": "redwoodjs",
    "Reebok": "reebok",
    "Refine": "refine",
    "Relay": "relay",
    "Reliance Industries Limited": "relianceindustrieslimited",
    "Remix": "remix",
    "Renault": "renault",
    "Render": "render",
    "Renovate": "renovate",
    "Replit": "replit",
    "Replay": "replay",
    "Republic of Gamers": "republicofgamers",
    "Rescript": "rescript",
    "Resend": "resend",
    "Resilio": "resilio",
    "RetroArch": "retroarch",
    "RetroPie": "retropie",
    "Reutlingen University": "reutlingenuniversity",
    "Reveald": "reveald",
    "Revolut": "revolut",
    "Revue": "revue",
    "REWE": "rewe",
    "Rezgo": "rezgo",
    "Rhinoceros": "rhinoceros",
    "Ria": "ria",
    "Rider": "rider",
    "Rimac Automobili": "rimacautomobili",
    "Ring": "ring",
    "Riot Games": "riotgames",
    "Ripple": "ripple",
    "Riseup": "riseup",
    "Givenchy": "givenchy",
    "Ritz-Carlton": "ritzcarlton",
    "River Island": "riverisland",
    "RoadRunner": "roadrunner",
    "Roblox": "roblox",
    "RoboMQ": "robomq",
    "Robot Framework": "robotframework",
    "Rocket.Chat": "rocketdotchat",
    "Rockstar Games": "rockstargames",
    "Rockwell Automation": "rockwellautomation",
    "Roku": "roku",
    "Rolls-Royce": "rollsroyce",
    "Rollup.js": "rollupdotjs",
    "Rome": "rome",
    "Roots": "roots",
    "Rootsbedrock": "rootsbedrock",
    "Rootsknowledge": "rootsknowledge",
    "Rootssage": "rootssage",
    "ROS": "ros",
    "Rossmann": "rossmann",
    "Rotary International": "rotaryinternational",
    "Rotten Tomatoes": "rottentomatoes",
    "Roundcube": "roundcube",
    "Rovio": "rovio",
    "Rsession": "rsession",
    "RSS": "rss",
    "RStudio": "rstudio",
    "RTE": "rte",
    "RTL": "rtl",
    "RTLZWEI": "rtlzwei",
    "RubBoT": "rubbot",
    "Ruby": "ruby",
    "Ruby on Rails": "rubyonrails",
    "RubyGems": "rubygems",
    "Rubymine": "rubymine",
    "Rumble": "rumble",
    "Runcom": "runcom",
    "Runkit": "runkit",
    "Runrun.it": "runrundotit",
    "Rust": "rust",
    "RxDB": "rxdb",
    "Ryanair": "ryanair",
    "Rye": "rye",
    "S7 Airlines": "s7airlines",
    "Saab": "saab",
    "Safari": "safari",
    "Sage": "sage",
    "Sahibinden": "sahibinden",
    "Salesforce": "salesforce",
    "Sally Beauty": "sallybeauty",
    "Salt Project": "saltproject",
    "Sams Club": "samsclub",
    "Samsung": "samsung",
    "Samsung Pay": "samsungpay",
    "SanDisk": "sandisk",
    "Sanic": "sanic",
    "Sanity": "sanity",
    "SAP": "sap",
    "Sass": "sass",
    "Satellizer": "satellizer",
    "Saturn": "saturn",
    "Sauce Labs": "saucelabs",
    "Scala": "scala",
    "Scaleway": "scaleway",
    "Scania": "scania",
    "Schemball": "schemball",
    "SCIEX": "sciex",
    "Scikit-learn": "scikitlearn",
    "SciPy": "scipy",
    "Scopus": "scopus",
    "Scorp": "scorp",
    "Scratch": "scratch",
    "Screencastify": "screencastify",
    "Scribd": "scribd",
    "Scrimba": "scrimba",
    "ScrollReveal": "scrollreveal",
    "Scrum Alliance": "scrumalliance",
    "Scrutinizer CI": "scrutinizerci",
    "ScyllaDB": "scylladb",
    "Seagate": "seagate",
    "SearXNG": "searxng",
    "SEAT": "seat",
    "SecurityScorecard": "securityscorecard",
    "Sega": "sega",
    "Selenium": "selenium",
    "Sellfy": "sellfy",
    "Semantic UI": "semanticui",
    "Semantic UI React": "semanticuireact",
    "Semantic Web": "semanticweb",
    "Semaphore CI": "semaphoreci",
    "Semrush": "semrush",
    "Sennheiser": "sennheiser",
    "Sensu": "sensu",
    "Sentry": "sentry",
    "Sepa": "sepa",
    "Sequelize": "sequelize",
    "Serverless": "serverless",
    "Session": "session",
    "Setapp": "setapp",
    "SFML": "sfml",
    "Shadow": "shadow",
    "Shadcn/ui": "shadcnui",
    "Shake Shack": "shakeshack",
    "Shanghai Metro": "shanghaimetro",
    "ShareX": "sharex",
    "Sharp": "sharp",
    "Shazam": "shazam",
    "Shell": "shell",
    "Shelly": "shelly",
    "Shenzhen Metro": "shenzhenmetro",
    "Shields.io": "shieldsdotio",
    "Shikimori": "shikimori",
    "Shopee": "shopee",
    "Shopify": "shopify",
    "Shopware": "shopware",
    "Shortcut": "shortcut",
    "Shotcut": "shotcut",
    "Showpad": "showpad",
    "Showtime": "showtime",
    "Shutterstock": "shutterstock",
    "Siemens": "siemens",
    "Sift": "sift",
    "Signal": "signal",
    "Signoz": "signoz",
    "Siigu": "siigu",
    "Silex": "silex",
    "Silicon Power": "siliconpower",
    "SilverStripe": "silverstripe",
    "Simple Analytics": "simpleanalytics",
    "Simple Icons": "simpleicons",
    "SimpleLogin": "simplelogin",
    "Simplenote": "simplenote",
    "Sina Weibo": "sinaweibo",
    "Singularity": "singularity",
    "Sinopec": "sinopec",
    "Sip": "sip",
    "SitePoint": "sitepoint",
    "Sketch": "sketch",
    "Sketchfab": "sketchfab",
    "SketchUp": "sketchup",
    "Skillshare": "skillshare",
    "Skoda": "skoda",
    "Sky": "sky",
    "Skype": "skype",
    "Skype for Business": "skypeforbusiness",
    "Slack": "slack",
    "Slackware": "slackware",
    "Slashdot": "slashdot",
    "Slick": "slick",
    "SlickPic": "slickpic",
    "SlideShare": "slideshare",
    "Slim": "slim",
    "Smart": "smart",
    "SmartThings": "smartthings",
    "Smashing Magazine": "smashingmagazine",
    "Smartsheet": "smartsheet",
    "SMB": "smb",
    "SMrt": "smrt",
    "SmugMug": "smugmug",
    "Snapchat": "snapchat",
    "Snapcraft": "snapcraft",
    "Snod": "snod",
    "Snowflake": "snowflake",
    "Snowpack": "snowpack",
    "Snyk": "snyk",
    "Social Blade": "socialblade",
    "Society6": "society6",
    "Socket.io": "socketdotio",
    "Sogou": "sogou",
    "Solana": "solana",
    "Solid": "solid",
    "SolidJS": "solidjs",
    "Solidity": "solidity",
    "Solus": "solus",
    "Sonar": "sonar",
    "SonarCloud": "sonarcloud",
    "SonarLint": "sonarlint",
    "SonarQube": "sonarqube",
    "Songkick": "songkick",
    "Songoda": "songoda",
    "SonicWall": "sonicwall",
    "Sonoff": "sonoff",
    "Sonos": "sonos",
    "SoundCharts": "soundcharts",
    "SoundCloud": "soundcloud",
    "Source Engine": "sourceengine",
    "SourceForge": "sourceforge",
    "Sourcegraph": "sourcegraph",
    "SourceHut": "sourcehut",
    "Sourcetree": "sourcetree",
    "Southwest Airlines": "southwestairlines",
    "SpaceX": "spacex",
    "Spacy": "spacy",
    "Spanx": "spanx",
    "Spark AR": "sparkar",
    "Sparkasse": "sparkasse",
    "SparkFun": "sparkfun",
    "SparkPost": "sparkpost",
    "SPDX": "spdx",
    "Speaker Deck": "speakerdeck",
    "Spectrum": "spectrum",
    "Speechify": "speechify",
    "Speedtest": "speedtest",
    "Spigot": "spigot",
    "Spinrilla": "spinrilla",
    "Splunk": "splunk",
    "Spoon": "spoon",
    "Spotify": "spotify",
    "Spotlight": "spotlight",
    "Spreadshirt": "spreadshirt",
    "Spreaker": "spreaker",
    "Spring": "spring",
    "Spring Boot": "springboot",
    "Spring Creators": "springcreators",
    "Spring Security": "springsecurity",
    "Spyder": "spyder",
    "SQL Developer": "sqldeveloper",
    "SQLite": "sqlite",
    "Square": "square",
    "Square Enix": "squareenix",
    "Squarespace": "squarespace",
    "Ssr": "ssr",
    "SSRN": "ssrn",
    "Stack Exchange": "stackexchange",
    "Stack Overflow": "stackoverflow",
    "StackBlitz": "stackblitz",
    "StackPath": "stackpath",
    "StackShare": "stackshare",
    "Stadia": "stadia",
    "Staffbase": "staffbase",
    "Standard JS": "standardjs",
    "Star Trek": "startrek",
    "Star Wars": "starwars",
    "Starbucks": "starbucks",
    "StarCitizen": "starcitizen",
    "Starling Bank": "starlingbank",
    "Starship": "starship",
    "Startrek": "startrek",
    "Starz": "starz",
    "Statamic": "statamic",
    "Statuspal": "statuspal",
    "Steam": "steam",
    "Steam Deck": "steamdeck",
    "SteamWorks": "steamworks",
    "Steem": "steem",
    "Steemit": "steemit",
    "Steinberg": "steinberg",
    "Stellar": "stellar",
    "Stencyl": "stencyl",
    "Stimulus": "stimulus",
    "Stitcher": "stitcher",
    "Stmicroelectronics": "stmicroelectronics",
    "Stoplight": "stoplight",
    "Storyblok": "storyblok",
    "Storybook": "storybook",
    "Strapi": "strapi",
    "Strava": "strava",
    "Streamlabs": "streamlabs",
    "Streamlit": "streamlit",
    "Stripe": "stripe",
    "StrongSwan": "strongswan",
    "StubHub": "stubhub",
    "Studio 3T": "studio3t",
    "Studyverse": "studyverse",
    "Styled-Components": "styledcomponents",
    "Stylelint": "stylelint",
    "Styleshare": "styleshare",
    "Stylus": "stylus",
    "Subaru": "subaru",
    "Sublime Text": "sublimetext",
    "Substack": "substack",
    "Subtitle Edit": "subtitleedit",
    "Subversion": "subversion",
    "Suckless": "suckless",
    "Sumo Logic": "sumologic",
    "Supercrease": "supercrease",
    "Superuser": "superuser",
    "Supabase": "supabase",
    "Supernovas": "supernovas",
    "SurrealDB": "surrealdb",
    "Suricata": "suricata",
    "SurveyMonkey": "surveymonkey",
    "Suse": "suse",
    "Suzuki": "suzuki",
    "Svelte": "svelte",
    "SVG": "svg",
    "SVGO": "svgo",
    "Swagger": "swagger",
    "Swarm": "swarm",
    "Swift": "swift",
    "Swiggy": "swiggy",
    "Swiper": "swiper",
    "Swr": "swr",
    "Symantec": "symantec",
    "Symfony": "symfony",
    "Symphony": "symphony",
    "Sympy": "sympy",
    "Synology": "synology",
    "System76": "system76",
    "Systemd": "systemd",
};
